import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateAllowedPaymentSystemsResponse } from '../types';
import {
  AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_API_URL,
  AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useAllowedPaymentSystemsQuery(): IContextQueryResult<IAffiliateAllowedPaymentSystemsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateAllowedPaymentSystemsResponse>({
    queryKey: [AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateAllowedPaymentSystemsResponse>(
      AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_API_URL,
      {
        signal,
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.SHOW,
      },
    ),
  });
}
